import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IApiErrorResult } from '@hub/interfaces/IApiErrorResult';
import { MessageService } from 'primeng/api';

@Injectable({ providedIn: 'root' })
export class NotificationService {
  constructor(
    private messageService: MessageService
  ) { }

  public success(message: string): void {
    this.messageService.add({ detail: message, severity: 'success' });
  }

  public successMultiple(messages: string[]): void {
    this.messageService.addAll(messages.map(m => ({ detail: m, severity: 'success' }) ));
  }

  public info(message: string): void {
    this.messageService.add({ detail: message, severity: 'info' });
  }

  public warning(message: string): void {
    this.messageService.add({ detail: message, severity: 'warn' });
  }

  public error(message: string): void {
    this.messageService.add({ detail: message, severity: 'error' });
  }

  public errorApi(error: IApiErrorResult) {
    if (!!error.ModelState['']) {
      this.error(error.ModelState[''].join('</br>'));
    }
  }

  public errorMultiple(messages: string[]): void {
    messages.forEach((message) =>
      this.messageService.add({ detail: message, severity: "error", life: 5000 })
    );
  }

  public errorResponse(response: HttpErrorResponse) {
    if (response.error && !!response.error['']) {
      this.messageService.addAll(response.error[''].map(m => ({ detail: m, severity: 'error' }) ));
    }
  }
}
